export default __webpack_public_path__ + "static/media/expresso_maly.9f88d2f2.png";